import { FC, useRef } from 'react';
import { Stage, StageStatus } from './ApplicationProgressBox';
import { cn } from 'lib/utils';
import { statusConfig } from './progressBoxData';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

const ProgressBar: FC<{ status: StageStatus; stageId: Stage }> = ({
  status,
  stageId,
}) => {
  const barRef = useRef<HTMLDivElement>(null);

  const targetProgress = {
    submitted: '100%',
    pending: '0%',
    'in-progress': '100%',
    rejected: '100%',
    complete: '100%',
  };

  useGSAP(() => {
    const isMobile = window.innerWidth < 640;

    if (isMobile) {
      // Vertical bar (fill upwards, full dynamic height)
      gsap.set(barRef.current, { height: '0%' });
      gsap.to(barRef.current, {
        delay: 0.4 + 0.4 * stageId,
        height: targetProgress[status],
        duration: 0.4,
        ease: 'linear.none',
      });
    } else {
      // Horizontal bar (fill rightwards)
      gsap.set(barRef.current, { width: '0%' });
      gsap.to(barRef.current, {
        delay: 0.4 + 0.4 * stageId,
        width: targetProgress[status],
        duration: 0.4,
        ease: 'linear.none',
      });
    }
  });

  return (
    <div className="w-[40px] flex justify-center sm:w-auto sm:block">
      {/* Track */}
      <div className="relative h-full sm:h-[6px] w-[6px] sm:w-full bg-white/[0.08] rounded-full overflow-hidden">
        {/* Fill */}
        <div
          ref={barRef}
          className={cn(
            'absolute bottom-0 left-0 w-full h-0 sm:h-full sm:w-0 bg-white rounded-full',
            statusConfig[status].barBg
          )}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
